import { useState } from 'react';
import { faqs } from '@/mocks/appData';

export default function FAQSection() {
  const [openId, setOpenId] = useState<number | null>(null);

  const toggle = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              常见问题
            </h2>
            <p className="text-sm text-foreground-600">关于CPP App的常见疑问解答</p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq) => (
              <div
                key={faq.id}
                className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => toggle(faq.id)}
                  className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
                >
                  <span className="text-sm font-medium text-foreground-800 pr-4">
                    {faq.question}
                  </span>
                  <div className={`w-6 h-6 flex items-center justify-center rounded-full flex-shrink-0 transition-colors duration-200 ${
                    openId === faq.id ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'
                  }`}>
                    <i className={`text-sm ${openId === faq.id ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                  </div>
                </button>
                <div
                  className={`transition-all duration-300 overflow-hidden ${
                    openId === faq.id ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                  }`}
                >
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}